import { isPostcodeValid } from '@pb/apps/offers/helpers/address';

export function isValidPostcode(postcode: string) {
    return postcode.length > 0 && isPostcodeValid(postcode);
}
